'use strict';

exports.__esModule = true;
exports.default = {
  LIGHT: 'light',
  DARK: 'dark'
};
//# sourceMappingURL=ColorScheme.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/constants/ColorScheme.js
// module id = 416
// module chunks = 198517197184460